import { isArrayEmpty, LayerViewModel, setupVariants } from "../../omnia"
import { SelectedLayerType } from "../types"
import { MapContext } from "./mapContext"

export function useLayerViewer(mapContext: MapContext, layerType: SelectedLayerType, layers: number[], opacity: number) {

    const dependencyKey = React.useMemo(() => layers?.join(","), [layers])

    const hasLayers = mapContext?.map && (!isArrayEmpty(layers))

    React.useEffect(() => {

        if (hasLayers) {
            return showLayers(mapContext, layerType, layers, opacity)
        }

    }, [mapContext, layerType, dependencyKey])

    React.useEffect(() => {

        if (hasLayers) {

            const set = new Set(layers)

            const instances = mapContext.map.getDataLayers(l => set.has(l.datalayerId))

            for (const l of instances) {
                l.opacity = opacity
            }

        }

    }, [mapContext, opacity, dependencyKey])

}

function showLayers(mapContext: MapContext, layerType: SelectedLayerType, layerIds: number[], opacity: number) {

    const { map, layerContext, loader } = mapContext

    let viewModels: LayerViewModel[]
    let disposed = false

    async function load() {

        const layers = await loader(layerIds)

        if (!disposed) {

            viewModels = layers.map(l => new LayerViewModel(layerContext, map, l))

            // Specific step to support dynamic scale layers
            // Need to call this setupVariants() function to assign the correct viewer
            // to the layers we are about to display
            if (layerType.dynamicScale) {
                const type = mapContext.getType(layerType.typeId)
                setupVariants(viewModels, type)
            }

            show(true)

        }


    }

    function show(visible: boolean) {

        if (viewModels) {
            for (const vm of viewModels) {
                vm.visible = visible
                vm.opacity = opacity
            }
        }

    }

    load()

    return () => {
        if (!disposed) {
            disposed = true
            show(false)
        }
    }

}
